import React from "react";
import { Route, Switch } from "react-router-dom";
// import "./antd.css";
// import "./styles.css";
import routes from "Utils/mainRoutes";
import Header from "./Header";
import Footer from "./Footer";

class CoreLayoutContainer extends React.Component {
  render() {
    return (
      <Switch>
        {routes.map((route, idx) => {
          return route.component ? (
            <Route
              key={idx}
              path={route.path}
              exact={route.exact}
              name={route.name}
              render={(props) => <route.component {...props} />}
            />
          ) : null;
        })}
      </Switch>
    );
  }
}

export default CoreLayoutContainer;
